import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import { LayoutDashboard, Target, Users, Upload, Radar, MessageSquare, FileText, BarChart3, Settings, Plug } from 'lucide-react';

const NAV_ITEMS = [
  { path: '/lead-finder', label: 'Dashboard', icon: LayoutDashboard, exact: true },
  { path: '/lead-finder/pipeline', label: 'Pipeline', icon: Users },
  { path: '/lead-finder/icp', label: 'ICPs', icon: Target },
  { path: '/lead-finder/sequences', label: 'Sequences', icon: MessageSquare },
  { path: '/lead-finder/templates', label: 'Templates', icon: FileText },
  { path: '/lead-finder/import', label: 'Import', icon: Upload },
  { path: '/lead-finder/analytics', label: 'Analytics', icon: BarChart3 },
  { path: '/lead-finder/extension', label: 'Extension', icon: Plug },
  { path: '/lead-finder/admin', label: 'Admin', icon: Settings },
];

export default function ProspectingNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isDark } = useTheme();

  return (
    <div className={`flex gap-1 overflow-x-auto pb-1 mb-5 border-b ${isDark ? 'border-white/10' : 'border-gray-200'}`} data-testid="prospecting-nav">
      {NAV_ITEMS.map(item => {
        const Icon = item.icon;
        const isActive = item.exact
          ? location.pathname === item.path
          : location.pathname === item.path || location.pathname.startsWith(item.path + '/');
        return (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            data-testid={`pnav-${item.label.toLowerCase()}`}
            className={`flex items-center gap-1.5 px-3 py-2 rounded-t-lg text-sm whitespace-nowrap transition-colors ${
              isActive
                ? 'bg-[#A2FF00]/10 text-[#A2FF00] border-b-2 border-[#A2FF00] font-medium'
                : isDark
                  ? 'text-gray-400 hover:text-white hover:bg-white/5'
                  : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'
            }`}
          >
            <Icon className="w-4 h-4" />
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
